export default __webpack_public_path__ + "static/media/FranceFlag.f8e69aab.png";